// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"365":"b806ca29","533":"1c422c89"}[chunkId] + ".chunk.css";
};